<ng-container *transloco="let t">
  @if (isArchived()) {
    <div class="row">
      <div class="col-12 my-2">
        <div class="alert alert-warning my-2" role="alert">
          <lucide-icon [img]="icons.archived"></lucide-icon> Cette activité est archivée.
        </div>
      </div>
    </div>
  }

  <div class="row">
    <div class="col">
      <p class="text-center mb-2 text-black text-opacity-25">
        informations fournies sans garanties
      </p>
    </div>
  </div>

  <div class="row justify-content-between gy-3">
    <div class="col-12 col-lg-auto">
      <h3 class="text-secondary">
        {{ activity()?.title ?? t('activity.item.Untitled') }}
      </h3>
      <p>
        <app-activity-tag-manager
          [activity]="activity()"
          [canModify]="canManageTags()">
        </app-activity-tag-manager>
      </p>
      <p>
        par
        <a [routerLink]="hostUrl()">{{ hostName() }}</a>
      </p>
    </div>
    @if (canEdit()) {
      <div class="col-12 col-lg-auto">
        <div class="d-grid gap-2 d-md-block">
          <button type="button" class="btn btn-sm btn-outline-primary"
                  (click)="editClick()">
            <lucide-icon [img]="icons.edit" [size]="16"></lucide-icon>
            Présenter l'activité
          </button>
        </div>
      </div>
    }
  </div>

  @if (activity()?.cover) {
    <div class="mt-3">
      <app-cover-viewer
        [url]="coverUrl()"
        [thumbnailUrl]="thumbnailUrl()">
      </app-cover-viewer>
    </div>
  }

  <div class="row my-2">
    <div class="col-12 ml-description">
      {{ activity()?.description }}
    </div>
  </div>
</ng-container>
